import React, { Component } from 'react';
import {Form, Control, Errors} from 'react-redux-form';
import {isRequired, number, required} from "../field_validations";
import DatePick from './../forms/datepicker';
import _ from "lodash";
import TextEditor from "../forms/wysiwyg_field";
import {toInt} from "../parsers";

export default class ProjectEditForm extends Component {
	render() {
		const {versions, modalities, entities, municipalities, projects} = this.props;
		let modData = _.find(modalities.list,{id: projects.project.modality_id});
		return (
			<div className="columns is-centered">
				<div className="column">
					<Form model="projects.project" onSubmit={(values) => this._submitForm(values)} onSubmitFailed={() => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}>
						<div className="field">
							<div className="control">
								<label htmlFor="name" className="label">Nombre del proyecto <span className="small has-text-danger">*</span></label>
								<Control.textarea rows="2" model=".name" id="name" className="textarea" errors={{isRequired}} validateOn="change" />
								<Errors model=".name" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control">
								<label htmlFor="version_id" className="label">Año <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".agency.version_id" id="version_id" className="select" errors={{required}} validateOn="change" parser={ toInt }>
										<option value=" " defaultValue>--- Año ---</option>
										{_.map(versions.list,(version, k) => {
											return <option value={version.id} key={k}>{version.year}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".version_id" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes elegir una año.'}} />
							</div>


							<div className="control">
								<label htmlFor="modality_id" className="label">Categoría <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".modality_id" id="modality_id" className="select" errors={{required}} validateOn="change" parser={ toInt } changeAction={(model,value) => this._changeMod(model,value)}>
										<option value=" " defaultValue>--- Categoría ---</option>
										{_.map(modalities.list,(modality, k) => {
											return <option value={modality.id} key={k}>{modality.name}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".modality_id" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes elegir una modalidad.'}} />
							</div>

							<div className="control">
								<label htmlFor="state_id" className="label">Estado</label>
								<div className={`select${entities.isFetching ? ' is-loading' : ''}`}>
									<Control.select id="state" model=".state_id" errors={{required}} validateOn="change" parser={ toInt } changeAction={(model,value) => this._changeState(model,value,modData)}>
										<option value="" defaultValue>--- Estado ---</option>
										{_.map(entities.list, (item, k) => {
											return <option key={k} value={item.id}>{item.name}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".state_id" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes elegir una entidad.'}} />
							</div>

							{(modData && modData.agenciable_type === 'imm') &&
								<div className="control">
									<label htmlFor="municipality" className="label">Municipio</label>
									<div className={`select${municipalities.isFetching ? ' is-loading' : ''}`}>
										<Control.select id="municipality_id" model=".municipality_id" errors={{required}} parser={ toInt } disabled={municipalities.isFetching}>
											<option value="" defaultValue>--- Municipios ---</option>
											{_.map(municipalities.list, (mun, j) => {
												return <option key={j} value={mun.id}>{mun.name}</option>
											})}
										</Control.select>
									</div>
									<Errors model=".municipality_id" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes elegir un municipio.'}} />
								</div>}
						</div>

						<div className="field is-grouped">
							<div className="control">
								<label htmlFor="code" className="label">Folio</label>
								<Control.text model=".code" id="code" type="number" min={1} step={1} className="input" changeAction={(m,v) => {this._changeCode(m,v)}} errors={{number}} validateOn="change"/>
								<Errors model=".code" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ number: 'El folio debe ser numérico'}} />
							</div>

							<div className="control is-expanded">
								<label htmlFor="execution_start" className="label">Fecha de ejecución inicial <span className="small has-text-danger">*</span></label>
								<Control.text model=".execution_start" errors={{isRequired}} validateOn="change" component={DatePick} className="input"  />
								<Errors model=".execution_start" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'La fecha es obligatoria'}}/>
							</div>

							<div className="control is-expanded">
								<label htmlFor="execution_end" className="label">Fecha de ejecución final <span className="small has-text-danger">*</span></label>
								<Control.text model=".execution_end" errors={{isRequired}} validateOn="change" id="end_date" component={DatePick} className="input" />
								<Errors model=".execution_end" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'La fecha es obligatoria'}}/>
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control">
								<div className="message is-primary">
									<div className="message-body">
										<div className="field">
											<div className="control">
												<label htmlFor="benefited" className="checkbox">
													<Control.checkbox model=".benefited" id="benefited" className="checkbox" isToggle={true}/>
													<span style={{whiteSpace:'normal'}}> Beneficiado </span>
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="field">
							<div className="control">
								<label htmlFor="objective" className="label">Objetivos <span className="small has-text-danger">*</span></label>
								<Control.textarea model=".objective" component={TextEditor} className="" id="objective" placeholder="Objetivos del proyecto" errors={{isRequired}} validateOn="change" />
								<Errors model=".objective" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'Los objectivos del proyecto son obligatorios'}}/>
							</div>
						</div>

						<div className="field">
							<div className="control">
								<label htmlFor="justification" className="label">Justificación <span className="small has-text-danger">*</span></label>
								<Control.textarea model=".justification" component={TextEditor} className="" id="justification" placeholder="Justificación del proyecto" errors={{isRequired}} validateOn="change" />
								<Errors model=".justification" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'La justificación del proyecto es obligatorio'}}/>
							</div>
						</div>

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-large" onClick={() => this.props.history.push(`/proyectos`)}>Regresar</button>
							</div>
							<div className="control">
								<Control.button model="projects.project.edit" className="button is-large is-inm-purple" type="submit" disabled={this._validateSave()}>Guardar</Control.button>
							</div>
						</div>
						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		)
	}

	_submitForm(values) {
		this.props.projectSave(values);
	}

	_changeCode(model,value){
		if(value){
			this.props.change(model,_.toNumber(value));
		}else {
			this.props.change(model,null);
		}
	}

	_changeMod(model,value){
		this.props.change(model,value);
		let {projects, modalities} = this.props;

		let modData = _.find(modalities.list,{id: value});
		this.props.change('projects.project.modality',{...modData})

		if(modData && modData.agenciable_type === 'imm'){
			if(projects.edit.state_id){
				this.props.fetchMunicipalities(projects.project.state_id);
			}
		}else {
			this.props.omit('projects.project', 'municipality_id');
		}

	}

	_changeState(model, value, modData){
		this.props.change(model, value)
		if(modData && modData.agenciable_type === 'imm'){
			this.props.fetchMunicipalities(value);
		}

	}

	_validateSave(){
		const {projects} = this.props;
		let pc = _.find(projects.permissions, (o) => o === 'Create');
		let pu = _.find(projects.permissions, (o) => o === 'Update');

		if(!_.isEmpty(projects.project) && projects.project.id){
			if(pu){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(projects.project) && _.isEmpty(projects.project.id)){
			if(pc){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}



// WEBPACK FOOTER //
// ./src/elements/projects/project.jsx